/**
 * Component used to catch errors when they're thrown.
 *
 * User friendly errors will be displayed tp
 */

import React, { Component } from 'react';
import Alert                from 'reactstrap/lib/Alert';
import UserFriendlyError    from '../../errors/UserFriendlyError';
import Raven                from '../../modules/raven-cdn';


class ErrorBoundary extends Component {

  constructor(props) {

    // noinspection JSCheckFunctionSignatures
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidCatch(error, info) {

    this.setState({error});

    if (!error instanceof UserFriendlyError) {

      Raven.captureException(error);

    }

  }

  render() {

    const {error} = this.state;

    if (error instanceof UserFriendlyError) {

      return <Alert color="danger">{error.message}</Alert>;

    }

    if (error) {

      return <Alert color="danger">Sorry.  Something went wrong.  Please reload the page, and try again.</Alert>;

    }

    return this.props.children;

  }
}


export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/generic/ErrorBoundry.js